module.exports = __webpack_public_path__ + "static/media/like-pressed-icon.5d12e154.svg";